import layout from '@/layout'

export default {
  path: '/application',
  component: layout,
  redirect: '/application/his',
  name: 'dongleUser',
  meta: {
    title: '应用管理',
    icon: 'application'
  },
  children: [
    {
      path: '/application/his',
      component: () => import('@/views/application/dongleUser'),
      meta: {
        title: 'his应用',
        icon: 'application-effect'
      }
    },
    {
      path: '/application/dongleUser/:id',
      component: () => import('@/views/application/dongleUser/info'),
      meta: {
        title: '加密狗用户详情'
      }
    },
    {
      path: '/application/dongleUser/module/:id',
      component: () => import('@/views/application/dongleUser/module'),
      meta: {
        title: '授权模块功能'
      }
    }
  ]
}
